const createButtonCompChecklist = {
  question: 'Create Question +'
};

export default createButtonCompChecklist;
